import AppManagementRequest from './AppManagementRequest';

export default class RemoveWQSystemRequest extends AppManagementRequest {
	constructor(createdBy, requirementNumber, app) {
		super(app, createdBy, requirementNumber);
		this.system = null; //BaseSystem.cs
	}
}
